import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  TextField, 
  Button, 
  Box, 
  Alert,
  Divider 
} from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const response = await api.post('/auth/login', formData);
      login(response.data.token, response.data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    setLoading(true);
    setError('');
    
    // Redirect to Google OAuth URL
    window.location.href = `https://jomlaline.net/api/auth/google`;
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, mb: 10 }}>
      <Typography variant="h4" gutterBottom align="center">
        تسجيل الدخول
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      {/* Google Login Button */}
      <Button
        fullWidth
        variant="outlined"
        onClick={handleGoogleLogin}
        disabled={loading}
        sx={{ 
          mb: 3, 
          py: 1.5,
          fontSize: '1rem'
        }}
      >
        <GoogleIcon />&nbsp;المتابعة عبر جوجل 
      </Button>

      <Divider sx={{ mb: 3 }}>- أو -</Divider>

      {/* Email/Password Form */}
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="الإيميل"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
          disabled={loading}
        />
        <TextField
          fullWidth
          margin="normal"
          label="كلمة المرور"
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
          disabled={loading}
        />
        <Button 
          type="submit" 
          variant="contained" 
          fullWidth 
          sx={{ mt: 3 }}
          disabled={loading}
        >
          {loading ? 'جار تسجيل الدخول ...' : 'تسجيل الدخول'}
        </Button>
      </Box>
      
      <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
        لا تمتلك حساب ؟{' '}
        <Button component="a" href="/register" color="primary">
          سجل من هنا
        </Button>
      </Typography>
    </Container>
  );
};

export default LoginPage;